import { NavigateFn } from '@tanstack/react-router';

export const navigationHelper = {
  navigate: null as NavigateFn | null,
}